export default {
  app: {
    golf: {
      title: 'Información del campo',
      hasEVChargingPoint: 'Punto de carga para vehículos eléctricos',
      hasCaddieService: 'Servicio de caddie',
      hasTrolley: 'Carrito',
      hasBuggy: 'Buggy',
      hasClubRental: 'Alquiler de palos',
      hasAcademy: 'Academia',
      hasMarshal: 'Marshal',
      hasPGACertification: 'Certificación PGA',
      hasTrainingArea: 'Área de entrenamiento',
      hasRestaurant: 'Restaurante',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Perros en el campo',
      numberOfHoles: 'Número de hoyos',
    },
  },
};
